import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import {Link} from "react-router-dom";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import {Box, Paper, Grid, Typography, Button} from '@material-ui/core/';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import * as Constants from "utils/constants";
import axios from "axios";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MuiAlert from "@material-ui/lab/Alert";


const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    flex: '1',
  },
  appBar: {
    position: 'relative',
    background: 'rgb(224, 68, 30)'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

function getOrderText(order) {
  var titleText = order.items.length+ " items (";
  order.items.forEach((item)=>{
      titleText = titleText+item.item_name;
      });
return titleText+")";
}

export default function Orders(props)  {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState("No result");

  React.useEffect(() => {
    if(props.currUser.default_tag != null) {
      axios.post(Constants.API_URL + "/api/shop/orders", {userid : props.currUser.id }
      ).then((response) => {
        console.log("user Orders");
        console.log(response.data);
        setResult(response.data.userOrders);
        setLoading(false);
      });
    }
  }, []);

  return (
    <React.Fragment>
      <CssBaseline />
      <Container spacing={5} className={classes.deals} maxWidth="md" component="main">
      {(props.currUser.length != 0) ? (
              loading ? (
                  <Box class="loader loader-quart"></Box>
              ) : (
                  <List component="nav" className={classes.root} aria-label="contacts">
                    <ListItem alignItems="flex-start">
                      <ListItemText
                          primary={getOrderText(result[0])}
                          secondary={<Typography type="body2" style={{ color: '#b3afaf' }}>Order Time : {result[0].booking_time}<br></br>Amount Paid : {result[0].amountPaid}</Typography>}
                      />
                    </ListItem>
                    <ListItem button>
                      <ListItemText inset primary="Eric Hoffman" />
                    </ListItem>
                  </List>
         )) : (
        <Box className="login_message">
          You need to <Link to="/signin">LOGIN</Link> to Add/View Tags
        </Box>
      )}
    </Container>
    </React.Fragment>
  );
}
